import React, { useRef, useState } from 'react';
import ImportQuestion from '../../../component/EliteGame/ImportQuestion';
import { ELITE_QUIZ_TYPE } from '../../../utils/constants';
import { importQuestions } from '../../../api/eliteGameApi';
import { errorToast, successToast } from '../../../utils/helper';
import { useEliteGames } from '../../../context/EliteGamesContext';
const sampleDataByQuizType = {
  MCQ: {
    headers: [
      { label: 'quiztype', key: 'quiztype' },
      { label: 'fun_learn_id', key: 'fun_learn_id' },
      { label: 'language', key: 'language' },
      { label: 'question_type', key: 'question_type' },
      { label: 'question', key: 'question' },
      { label: 'option 1', key: 'option1' },
      { label: 'option 2', key: 'option2' },
      { label: 'option 3', key: 'option3' },
      { label: 'option 4', key: 'option4' },
      { label: 'answer', key: 'answer' },
      { label: 'level', key: 'level' },
      { label: 'note', key: 'note' }
    ],
    data: [
      {
        quiztype: '3',
        fun_learn_id: 63,
        language: 'english',
        question_type: '{2 if question_type is true false other wise 1}',
        question: 'Sample MCQ Question?',
        option1: 'a',
        option2: 'b',
        option3: 'c',
        option4: 'd',
        answer: 'a',
        level: 1,
        note: 'This is a sample MCQ'
      },
      {
        quiztype: '3',
        fun_learn_id: 63,
        language: 'english',
        question_type: '{2 if question_type is true false other wise 1}',
        question: 'Is the sky blue?',
        option1: 'TRUE',
        option2: 'FALSE',
        option3: '{leave this blank cell if question_type is true/false}',
        option4: '{leave this blank cell if question_type is true/false}',
        answer: 'true',
        level: 2,
        note: 'Sample True/False'
      }
    ]
  }
};
const FunLearnImportQues = () => {
  const [examModuleType, setExamModuleType] = useState('MCQ');
  const [refresh, setRefresh] = useState(false);
  const importRef = useRef(); // ✅ ref to trigger child reset

  const { setLoading } = useEliteGames();
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await importQuestions(data, ELITE_QUIZ_TYPE.FUN_N_LEARN);
      console.log('Questions imported successfully:', response);
      successToast('Questions imported successfully!');
      importRef.current?.reset(); // ✅ reset child input after success
    } catch (error) {
      errorToast('No data to submit', error.message);
    } finally {
      setLoading(false);
    }
    setRefresh(!refresh);
  };
  const { headers, data } = sampleDataByQuizType[examModuleType];
  return (
    <div>
      <ImportQuestion
        ref={importRef}
        onSubmit={onSubmit}
        sampleData={data}
        headers={headers}
        filename={`${examModuleType.toLowerCase()}-sample.csv`}
      />
    </div>
  );
};

export default FunLearnImportQues;
